import styled from "../styles";
import withMargin from "../styles/withMargin";
import { Text } from "./Text";

export const Subtitle = styled(Text)`
  color: ${(p) => p.theme.color.typography.secondary};
  ${withMargin}
`;
